import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { map } from "rxjs";
import { IBaseSearchRequest } from "src/app/core/models/base";
import { ProductService } from "src/app/products/services/product.service";

export function ProductInternalNumberValidator(productService: ProductService): AsyncValidatorFn {
    return  (control: AbstractControl) => {
        const request : IBaseSearchRequest= {
            pageNumber:0,
            pageSize: 999999,
            advancedFilter:{
                logic: "and",
                filters: [
                    {
                        field: 'internalNumber',
                        operator: 'eq',
                        value: control.value

                    }
                ]
            }
        }

        return productService.listProducts(request)
        .pipe(
            map(response => {
                const products = response.data;

                return products.length != 0 ? {internalNumberExists: true} : null;
            })
        )
    }
}
